import { render } from "./ComponenteAnimacionLoginOphelia.vue?vue&type=template&id=a9920f48&scoped=true"
import script from "./ComponenteAnimacionLoginOphelia.vue?vue&type=script&lang=js"
export * from "./ComponenteAnimacionLoginOphelia.vue?vue&type=script&lang=js"

import "./ComponenteAnimacionLoginOphelia.vue?vue&type=style&index=0&id=a9920f48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9920f48"]])

export default __exports__